import React from 'react';

const Testimonial = () => {
  return (
      <div className="homepage-testimonial">
          <p>"Perfect Lawyer... Our company would not be as successful as it is without Pete guiding us and being in our corner." <br/> <br/>
              <span> Greg Sinigiani, President Sinigiani Investment Corp </span>
          </p>
      </div>
  );
}
export default Testimonial;



// WEBPACK FOOTER //
// ./src/components/Testimonial.js